(function () {
  if (window.__sgYotpoScrollInstalled) return;
  window.__sgYotpoScrollInstalled = true;

  function headerOffset() {
    const cssVar = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
    const varNum = parseInt(cssVar, 10);
    if (!isNaN(varNum) && varNum > 0) return varNum + 12;

    const header =
      document.querySelector('#shopify-section-header') ||
      document.querySelector('.Header') ||
      document.querySelector('header');

    return (header ? header.offsetHeight : 0) + 12;
  }

  function findTarget() {
    return (
      document.getElementById('yotpo-reviews-main-widget') ||
      document.querySelector('.yotpo-main-layout.yotpo-main-reviews-widget') ||
      document.querySelector('.yotpo-main-widget-layout')
    );
  }

  function scrollOnce() {
    const t = findTarget();
    if (!t) return false;
    const y = Math.round(t.getBoundingClientRect().top + window.pageYOffset - headerOffset());
    window.scrollTo(0, y);
    return true;
  }

  function scheduleScroll() {
    setTimeout(scrollOnce, 0);
    setTimeout(scrollOnce, 50);
    setTimeout(scrollOnce, 150);
    setTimeout(scrollOnce, 300);
    setTimeout(scrollOnce, 600);
  }

  document.addEventListener(
    'click',
    function (e) {
      const hit = e.target.closest(
        '.ProductMeta__ReviewsSummary, .ProductMeta__ReviewsSummary *,' +
        '.yotpo-bottomline, .yotpo.bottomLine, .yotpo-stars, .yotpo-icon-star, .text-m'
      );
      if (!hit) return;

      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();

      scheduleScroll();
    },
    true
  );
})();
